angular.module('impactx.basket').service('BANFService', [
    '$mdDialog',
    'dataGen',
    '$route',
    '$redirect',
    BANFService
]);

function BANFService($mdDialog, dataGen, $route, $redirect) {

    function showAddBANFDialog(ev, context, banfContractId) {
        var basketItemId = 0;

        var entryPointGet = "/basket/item/freeform/view/banf";
        var entryPointSave = "/basket/item/freeform/save";
        var controller = "EditFreeFormCtrl";

        $mdDialog.show({
            controller: controller,
            templateUrl: 'shared/requestitem/templates/requestitemdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                itemId: basketItemId,
                headerId: 0,
                entryPointGet: entryPointGet,
                entryPointSave: entryPointSave,
                changeAATEntryPoint: '/basket/item/updateavailablecontrols',
                lotId: 0,
                productId: -1,
                readOnly: false,
                materialGroupMappingEntryPoint: "/basket/input/eclassmapping",
                hideOrderData: false,
                headerTable: "BKH",
                contractId: banfContractId ? banfContractId : 0
            }
        }).then(function () {
            context.refreshBasket({}, dataGen, context);
            var currentRoute = $route.current.$$route.originalPath;
            if (currentRoute === "/basket") {
                $route.reload();
            }
            else {
                $redirect.redirectTo(null, "/basket")
            }
        });
    }

    function showAddBANFOfferDialog (ev, context) {
        $mdDialog.show({
            controller: "EditFreeFormOfferCtrl",
            controllerAs: "editFreeFormOfferCtrl",
            templateUrl: 'modules/basket/templates/freeformofferdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                basketItemGroupId: 0,
                headerId: 0,
                hideOrderData: false,
                lotId: 0,
                supplierId: 0,
                product: null,
                allowBANF: true,
                onlyBANF: true
            }
        }).then(function (answer) {
            if (answer && answer.freeformContract) {
                showAddBANFDialog(ev, context, answer.freeformContract.id);
            }
            else {
                context.refreshBasket({}, dataGen, context);
                var currentRoute = $route.current.$$route.originalPath;
                if (currentRoute === "/basket") {
                    $route.reload();
                }
                else {
                    $redirect.redirectTo(null, "/basket")
                }
            }
            });
    }

    return {
        showAddBANFDialog: showAddBANFDialog,
        showAddBANFOfferDialog: showAddBANFOfferDialog
    };
}